import { jsx } from 'react/jsx-runtime';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-illustrations.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSIllustrations = props => {
  const {
    className,
    alt,
    url
  } = props;
  const cssClassNames = getClassNameList('uitk-illustration', className);
  return url ? jsx("img", {
    className: cssClassNames,
    alt: alt,
    src: url
  }) : null;
};
EGDSIllustrations.displayName = 'EGDSIllustrations';
export { EGDSIllustrations };